import SafeImage from '@/components/SafeImage';

const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20warm%20friendly%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20circular%20portrait%20composition&width=120&height=120&seq=avatar-user-01&orientation=squarish',
    name: '影迷小王',
    time: '2天前',
    content: '牛牛超清真的名不虚传！用手机流量看4K画质居然一点都不卡，比我之前用的其他平台流畅太多了。片库也全，想看的剧基本都有，已经推荐给身边所有追剧的朋友了。',
    show: '长安秘闻录',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20woman%20with%20gentle%20expression%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20circular%20portrait&width=120&height=120&seq=avatar-user-02&orientation=squarish',
    name: '追剧少女',
    time: '3天前',
    content: '免费、高清、不卡顿，这三个词放在一起以前我是不信的。直到朋友让我试试牛牛影视，彻底改变了我的认知。现在每天睡前必刷，沉浸式追剧幸福感拉满。',
    show: '盛夏光年',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20middle-aged%20Asian%20man%20with%20confident%20look%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20business%20casual%20style%2C%20circular%20portrait&width=120&height=120&seq=avatar-user-03&orientation=squarish',
    name: '老影虫',
    time: '5天前',
    content: '作为一个看了二十年电影的资深影迷，牛牛影视的片库深度让我惊喜。很多冷门老片都能找到超清修复版，而且播放时完全没有缓冲等待，观影体验堪称完美。',
    show: '正义之名',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20woman%20with%20bright%20smile%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%2C%20fresh%20casual%20style%2C%20circular%20portrait&width=120&height=120&seq=avatar-user-04&orientation=squarish',
    name: '剧荒拯救者',
    time: '1周前',
    content: '牛牛影视的推荐算法太懂我了！每次剧荒的时候打开首页，总能发现合口味的新片。从古装到现代、从悬疑到甜宠，分类清晰、更新及时，彻底告别选择困难症。',
    show: '云端幻想曲',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20thoughtful%20expression%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20style%2C%20circular%20portrait&width=120&height=120&seq=avatar-user-05&orientation=squarish',
    name: '深夜观影人',
    time: '1周前',
    content: '牛牛极清画质配合我的4K显示器简直是绝配。最让我满意的是没有强制广告，追剧时不会被打断。希望牛牛影视越来越好，让更多人享受到这种纯粹的观影快乐。',
    show: '星际迷途',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          用户评价
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          来自真实牛牛用户的观影心声
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3 md:mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <SafeImage
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium">
                <i className="ri-movie-2-line text-xs"></i>
                正在看《{comment.show}》
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}